import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'
import { SwapOrReturnStatusEnum } from '../../SwapOrReturnTypes'

export const CustomButton = styled(ButtonMui)`
  width: 16rem;
`

export const CustomButtonNavigate = styled(ButtonMui)`
  width: 10rem;
`

export const BodyModalAlert = styled.div`
  display: flex;
  width: 100%;
  margin: 1rem;
`

export const AlertMessageBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  word-wrap: break-word;
`

export const AlertMessage = styled.span`
`

export const StatusBox = styled.div<{ show: boolean, status: string | undefined }>`
  display: ${({ show }) => (show ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  align-self: center;
  height: 2rem;
  padding-left: 3rem;
  padding-right: 3rem;
  border-radius: 15px;
  background-color: ${({ status }) => {
    if (status === SwapOrReturnStatusEnum.CREATED || status === SwapOrReturnStatusEnum.PENDING) {
      return '#B9B9B9'
    } if (status === SwapOrReturnStatusEnum.IN_RESOLUTION) {
      return '#00FFF7'
    } if (status === SwapOrReturnStatusEnum.WAITING_RELEASE) {
      return '#FFC800'
    } if (status === SwapOrReturnStatusEnum.RESOLVED) {
      return '#17FF00'
    } if (status === SwapOrReturnStatusEnum.CANCELED) {
      return '#FF0000'
    }
    return '#FFFFFF'
  }};
`
